import { Grid, Typography, TextField, Button, Link } from '@mui/material'
import colors from '../../../../../colors'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sendGeneralRequest } from '../../../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import { selectMyContractsState, setShouldFillFields } from '../../../../../../features/myContracts/myContractsSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../../../general/texts';
import SelectKredoPayment from './SelectKredoPayment';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const Kredo = (props) => {

    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()
    const [loan, setLoan] = useState('personal')
    const [selectPayment, setSelectPayment] = useState(false)
    const [loanModelData, setLoanModelData] = useState([])
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        token: props.globalDataSliceState.token,
        accountNumber: '',
        id: '',
    })
    const dispatch = useDispatch()

    const handleTextFieldChange = (prop) => (e) => {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const SearchKredoLoanToPay = () => {
        dispatch(sendGeneralRequest({ request: { token: state.token, isPersonal: loan === 'personal' ? true : false, loanRef: state.accountNumber, personalNo: state.id }, baseUrlKey: 'services', endpoint: 'Kredo/SearchKredoLoanToPay' })).then(response => {
            if (response.payload.response.success){
                setSelectPayment(true)
                setLoanModelData(response.payload.response.loanData)
            }
        })
    }

    React.useEffect(() => {
        if (myContractsSliceState.shouldFillFields) {
            setState({
                ...state,
                accountNumber: props.selectedContractInfo.contract,
                id: props.selectedContractInfo.description
            })
            dispatch(setShouldFillFields(false))
        }
    }, [myContractsSliceState.shouldFillFields])

    const isButtonDisabled = () => {
        return (!state.accountNumber && loan === 'personal') || ((!state.id || !state.accountNumber) && loan === 'nonPersonal')
    }

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%',
            height: isSmallScreen ? '85vh' : '450px'
        },
        utilityName: {
            color: props.utilityInfo.Color,
            fontSize: '1.5rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '70px',
            height: '70px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold'
        },
        buttonGrid: {
            marginTop: 180,
            paddingBottom: 5
        },
        image: {
            width: '70%',
        },
        textField: {
            width: '100%'
        }
    })

    const classes = useStyles()

    return (
        <>
            {selectPayment ? (
                <SelectKredoPayment data={props} loanData={loanModelData} isPersonal={loan === 'personal' ? true : false} />
            ) : (
                <Grid container item className={classes.mainGrid} rowSpacing={2}>
                    <Grid container item md={2} xs={2} mt={2} >
                        <Link component={'button'} onClick={() => { navigate(-1) }}>
                            <ArrowBackIosNewIcon color='warning' />
                        </Link>
                    </Grid>
                    <Grid container item md={12} xs={12}>
                        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} >
                            <img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image} />
                        </Grid>
                        <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
                    </Grid>
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20, marginTop: 20 }}>
                        <Button onClick={() => setLoan('personal')} style={{ textTransform: 'none', background: loan === 'personal' ? colors.lightOrange : colors.lightGray, border: loan === 'personal' ? '2px solid #EF7a30' : 'none', padding: 8, color: loan === 'personal' ? colors.orange : colors.darkBlue, width: '102px', marginRight: 40, fontFamily: 'GerberaBold', borderRadius: '8px' }}>{texts['button-personal']}</Button>
                        <Button onClick={() => setLoan('nonPersonal')} style={{ textTransform: 'none', background: loan === 'nonPersonal' ? colors.lightOrange : colors.lightGray, border: loan === 'nonPersonal' ? '2px solid #EF7a30' : 'none', padding: 8, color: loan === 'nonPersonal' ? colors.orange : colors.darkBlue, fontFamily: 'GerberaBold', borderRadius: '8px' }}>{texts['button-non-personal']}</Button>
                    </div>
                    <Grid container item md={12} xs={12} >
                        <Typography className={classes.fieldTitle}>{texts["prompt-fill-fields"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12}  >
                        <TextField onChange={handleTextFieldChange('accountNumber')} value={state.accountNumber} color='warning' size='small' label={texts["title-reference-loan"]} className={classes.textField} />
                    </Grid>
                    <Grid container item md={12} xs={12} >
                        {
                            loan === 'nonPersonal' && (
                                <TextField onChange={handleTextFieldChange('id')} value={state.id} color='warning' size='small' label={texts["title-registration-idNumber"]} className={classes.textField} />
                            )
                        }
                    </Grid>
                    <Grid item md={12} xs={12} className={classes.buttonGrid} >
                        <Button disabled={isButtonDisabled()} onClick={SearchKredoLoanToPay} className={classes.button}>
                            {texts["title-pay"]}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </>
    )
}

export default Kredo;
